import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { SvgYearInReviewTextFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewTextFull";

interface YearInReviewGeneratePageProps {
  onGenerate?: () => void;
  riotUserName: string;
  riotTagLine: string;
  isLoading?: boolean;
}

export const YearInReviewGeneratePage = ({
  onGenerate,
  riotUserName,
  riotTagLine,
  isLoading = false,
}: YearInReviewGeneratePageProps) => {
  return (
    <div className="flex flex-col items-center gap-[60px]">
      <div className="flex space-x-[19px] justify-center">
        <Icon icon={<SvgYearInReviewLogoFull />} className="w-[104.273px] h-[100px]" />
        <div className="flex flex-col space-y-[20px]">
          <Icon icon={<SvgYearInReviewTextFull />} className="w-[156.779px] h-[76.266px] " />
          <div className="w-[154.933px] h-[3.35px] bg-[#D3A752] drop-shadow-[0_2px_2px_rgba(0,0,0,0.25)]  border-0" />
        </div>
      </div>
      <h1 className="text-center text-[96px] font-medium uppercase leading-normal tracking-normal drop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] bg-gradient-to-b from-[#F4C874_25%] to-[#D3A752_84%] bg-clip-text text-transparent">
        {riotUserName} #{riotTagLine}
      </h1>
      <p className="text-center text-sm font-normal leading-normal text-[#CDDCFE] font-inter">
        Generating your Year in Review pulls data exclusively from your public League of Legends
        <br /> match history to create personalized stats, highlights, and achievements.
        <br />
        <br />
        Only publicly available information will be accessed, ensuring your privacy is protected.
        <br />
        A minimum of 25 games is needed to generate your Year in Review.
        <br />
        Premium users will be put into a priority queue!
      </p>
      <button
        onClick={onGenerate}
        disabled={isLoading}
        className="cursor-pointer flex h-[48px] w-[240px] shrink-0 items-center justify-center rounded-[3px] bg-[#25254B] px-3 py-2.5 shadow-[inset_0_1px_0_0_#575792,0_2px_4px_0_rgba(0,0,0,0.25)] text-white font-inter text-[18px] font-bold leading-normal transition-all duration-200 hover:brightness-125 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span>{isLoading ? "Generating..." : "Generate"}</span>
      </button>
    </div>
  );
};
